import React, { useState } from "react";
import { FaPlus, FaTrash, FaChevronUp, FaChevronDown } from "react-icons/fa";
import {
  createEmptyMembership,
  createEmptyPublication,
  createEmptyAward,
  createEmptyReference,
  MEMBERSHIP_STATUS_OPTIONS,
  CONSENT_OPTIONS,
} from "../constants";

const Tab5References = ({
  membershipRecords,
  setMembershipRecords,
  publicationRecords,
  setPublicationRecords,
  awardRecords,
  setAwardRecords,
  referenceRecords,
  setReferenceRecords,
  loading,
  addRecord,
  removeRecord,
  handleRecordChange,
  onSubmitMembershipsPublicationsAwards,
  onSubmit,
  onBack,
}) => {
  const [expandedSections, setExpandedSections] = useState({
    memberships: true,
    publications: true,
    awards: true,
    references: true,
  });

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div>
      {/* Section 17: Memberships / Publications / Awards */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("memberships")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🏆</span>
              17. Memberships / Publications / Awards
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.memberships ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Professional memberships, publications and awards.
          </p>
        </div>

        {expandedSections.memberships && (
          <>
            {/* Professional Memberships */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div className="register-stage2-section__header-row">
                <div>
                  <h4 className="register-stage2-section__subtitle">
                    Professional membership
                  </h4>
                  <p className="register-stage2-section__help-text">
                    Add one or more memberships with organisation, grade, number,
                    start date, and status.
                  </p>
                </div>
              </div>

              {membershipRecords.map((record, index) => (
                <div key={record.id} className="register-stage2-record-card">
                  <div className="register-stage2-record-card__header">
                    <h4 className="register-stage2-record-card__title">
                      Professional membership #{index + 1}
                    </h4>
                    {membershipRecords.length > 1 && (
                      <button
                        type="button"
                        className="register-stage2-record-card__remove"
                        onClick={() =>
                          removeRecord(
                            setMembershipRecords,
                            index,
                            createEmptyMembership,
                          )
                        }
                        disabled={loading}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                  <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Body / Institution
                      </label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={record.body_institution}
                        onChange={(e) =>
                          handleRecordChange(
                            setMembershipRecords,
                            index,
                            "body_institution",
                            e.target.value,
                          )
                        }
                        placeholder="Body / institution"
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Grade</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={record.grade}
                        onChange={(e) =>
                          handleRecordChange(
                            setMembershipRecords,
                            index,
                            "grade",
                            e.target.value,
                          )
                        }
                        placeholder="Grade"
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Membership Number
                      </label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={record.membership_number}
                        onChange={(e) =>
                          handleRecordChange(
                            setMembershipRecords,
                            index,
                            "membership_number",
                            e.target.value,
                          )
                        }
                        placeholder="Membership number"
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Start Date
                      </label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={record.start_date}
                        onChange={(e) =>
                          handleRecordChange(
                            setMembershipRecords,
                            index,
                            "start_date",
                            e.target.value,
                          )
                        }
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                      <div className="register-stage2-form__field-group">
                        <label className="register-stage2-form__label">
                          Status
                        </label>
                        <select
                          className="register-stage2-form__select"
                          value={record.status}
                          onChange={(e) =>
                            handleRecordChange(
                              setMembershipRecords,
                              index,
                              "status",
                              e.target.value,
                            )
                          }
                          disabled={loading}
                        >
                          <option value="">Select status...</option>
                          {MEMBERSHIP_STATUS_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="register-stage2-add-btn"
                onClick={() =>
                  addRecord(setMembershipRecords, createEmptyMembership)
                }
                disabled={loading}
              >
                <FaPlus /> Add professional membership
              </button>
            </div>

            {/* Publications - Subsection with expand/collapse */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div
                className="register-stage2-section__header"
                onClick={() => toggleSection("publications")}
                style={{ cursor: "pointer" }}
              >
                <div className="register-stage2-section__header-top">
                  <h4 className="register-stage2-section__subtitle">Publication</h4>
                  <span className="register-stage2-section__chevron">
                    {expandedSections.publications ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>
                <p className="register-stage2-section__help-text">
                  Add one or more publications with title, publisher, date, and
                  link.
                </p>
              </div>

              {expandedSections.publications && (
                <>
                  {publicationRecords.map((record, index) => (
                    <div key={record.id} className="register-stage2-record-card">
                      <div className="register-stage2-record-card__header">
                        <h4 className="register-stage2-record-card__title">
                          Publication #{index + 1}
                        </h4>
                        {publicationRecords.length > 1 && (
                          <button
                            type="button"
                            className="register-stage2-record-card__remove"
                            onClick={() =>
                              removeRecord(
                                setPublicationRecords,
                                index,
                                createEmptyPublication,
                              )
                            }
                            disabled={loading}
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                      <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">Title</label>
                          <input
                            type="text"
                            className="register-stage2-form__input"
                            value={record.title}
                            onChange={(e) =>
                              handleRecordChange(
                                setPublicationRecords,
                                index,
                                "title",
                                e.target.value,
                              )
                            }
                            placeholder="Title"
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Publisher
                          </label>
                          <input
                            type="text"
                            className="register-stage2-form__input"
                            value={record.publisher}
                            onChange={(e) =>
                              handleRecordChange(
                                setPublicationRecords,
                                index,
                                "publisher",
                                e.target.value,
                              )
                            }
                            placeholder="Publisher"
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">Date</label>
                          <input
                            type="date"
                            className="register-stage2-form__input"
                            value={record.date}
                            onChange={(e) =>
                              handleRecordChange(
                                setPublicationRecords,
                                index,
                                "date",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">URL</label>
                          <input
                            type="url"
                            className="register-stage2-form__input"
                            value={record.url}
                            onChange={(e) =>
                              handleRecordChange(
                                setPublicationRecords,
                                index,
                                "url",
                                e.target.value,
                              )
                            }
                            placeholder="URL"
                            disabled={loading}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="register-stage2-add-btn"
                    onClick={() =>
                      addRecord(setPublicationRecords, createEmptyPublication)
                    }
                    disabled={loading}
                  >
                    <FaPlus /> Add publication
                  </button>
                </>
              )}
            </div>

            {/* Awards & Recognition - Subsection with expand/collapse */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div
                className="register-stage2-section__header"
                onClick={() => toggleSection("awards")}
                style={{ cursor: "pointer" }}
              >
                <div className="register-stage2-section__header-top">
                  <h4 className="register-stage2-section__subtitle">
                    Award / recognition
                  </h4>
                  <span className="register-stage2-section__chevron">
                    {expandedSections.awards ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>
                <p className="register-stage2-section__help-text">
                  Add awards, recognitions, or achievements with date and context.
                </p>
              </div>

              {expandedSections.awards && (
                <>
                  {awardRecords.map((record, index) => (
                    <div key={record.id} className="register-stage2-record-card">
                      <div className="register-stage2-record-card__header">
                        <h4 className="register-stage2-record-card__title">
                          Award / recognition #{index + 1}
                        </h4>
                        {awardRecords.length > 1 && (
                          <button
                            type="button"
                            className="register-stage2-record-card__remove"
                            onClick={() =>
                              removeRecord(setAwardRecords, index, createEmptyAward)
                            }
                            disabled={loading}
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                      <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Award Name
                          </label>
                          <input
                            type="text"
                            className="register-stage2-form__input"
                            value={record.award_name}
                            onChange={(e) =>
                              handleRecordChange(
                                setAwardRecords,
                                index,
                                "award_name",
                                e.target.value,
                              )
                            }
                            placeholder="Award name"
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Issuer
                          </label>
                          <input
                            type="text"
                            className="register-stage2-form__input"
                            value={record.issuer}
                            onChange={(e) =>
                              handleRecordChange(
                                setAwardRecords,
                                index,
                                "issuer",
                                e.target.value,
                              )
                            }
                            placeholder="Issuer"
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">Date</label>
                          <input
                            type="date"
                            className="register-stage2-form__input"
                            value={record.date}
                            onChange={(e) =>
                              handleRecordChange(
                                setAwardRecords,
                                index,
                                "date",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                          <div className="register-stage2-form__field-group">
                            <label className="register-stage2-form__label">
                              Reason / Context
                            </label>
                            <textarea
                              className="register-stage2-form__textarea"
                              rows="2"
                              value={record.reason_context}
                              onChange={(e) =>
                                handleRecordChange(
                                  setAwardRecords,
                                  index,
                                  "reason_context",
                                  e.target.value,
                                )
                              }
                              placeholder="Reason / context"
                              disabled={loading}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="register-stage2-add-btn"
                    onClick={() => addRecord(setAwardRecords, createEmptyAward)}
                    disabled={loading}
                  >
                    <FaPlus /> Add award / recognition
                  </button>
                  <div className="register-stage2-form__actions register-stage2-form__actions--inline">
                    <button
                      type="button"
                      className="register-stage2-form__btn register-stage2-form__btn--primary"
                      onClick={onSubmitMembershipsPublicationsAwards}
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>

      {/* Section 18: References */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("references")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">👥</span>
              18. References
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.references ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Professional references.
          </p>
        </div>

        {expandedSections.references && (
          <>
            {referenceRecords.map((record, index) => (
              <div
                key={record.id}
                className="register-stage2-record-card register-stage2-record-card--compact"
              >
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Reference #{index + 1}
                  </h4>
                  {referenceRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() =>
                        removeRecord(
                          setReferenceRecords,
                          index,
                          createEmptyReference,
                        )
                      }
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.name}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "name",
                          e.target.value,
                        )
                      }
                      placeholder="Full name"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Job Title
                    </label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.job_title}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "job_title",
                          e.target.value,
                        )
                      }
                      placeholder="Job title"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Organisation
                    </label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.organisation}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "organisation",
                          e.target.value,
                        )
                      }
                      placeholder="Organisation"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Relationship
                    </label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.relationship}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "relationship",
                          e.target.value,
                        )
                      }
                      placeholder="Former supervisor, client contact..."
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Email</label>
                    <input
                      type="email"
                      className="register-stage2-form__input"
                      value={record.email}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "email",
                          e.target.value,
                        )
                      }
                      placeholder="Email"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Phone</label>
                    <input
                      type="tel"
                      className="register-stage2-form__input"
                      value={record.phone}
                      onChange={(e) =>
                        handleRecordChange(
                          setReferenceRecords,
                          index,
                          "phone",
                          e.target.value,
                        )
                      }
                      placeholder="Phone"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Consent to share obtained
                      </label>
                      <select
                        className="register-stage2-form__select"
                        value={record.consent_to_share}
                        onChange={(e) =>
                          handleRecordChange(
                            setReferenceRecords,
                            index,
                            "consent_to_share",
                            e.target.value,
                          )
                        }
                        disabled={loading}
                      >
                        <option value="">Select...</option>
                        {CONSENT_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setReferenceRecords, createEmptyReference)}
              disabled={loading}
            >
              <FaPlus /> Add Reference
            </button>
          </>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="register-stage2-form__actions">
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--outline"
          onClick={onBack}
          disabled={loading}
        >
          ← Previous Tab
        </button>
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit & Continue"}
        </button>
      </div>
    </div>
  );
};

export default Tab5References;